<template>
  <div
    class="d-flex range-wrap"
    :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'"
  >
    <!-- SELECT RANGE -->
    <div class="flex-grow-1 px-2 pb-3">
      <v-select
        v-model="select"
        :items="items"
        item-text="label"
        item-value="value"
        :label="$t('intervalsLable')"
        hide-details
        solo-inverted
        return-object
        prepend-icon="mdi-calendar-range"
        dense
        :disabled="disabledRangeSelect"
      ></v-select>
    </div>

    <!-- RANGE MENU - 1 - DATA_INÍCIO -->
    <div class="d-flex flex-grow-1 px-2 pb-3">
      <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :nudge-right="40"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date_start_br"
            label=""
            prepend-icon="mdi-calendar-today"
            :prefix="$t('fromDateLable')"
            readonly
            solo-inverted
            hide-details
            dense
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date_start"
          @input="menu1 = false"
          :locale="$t('localeDatepickLable')"
        ></v-date-picker>
      </v-menu>
    </div>

    <!-- RANGE MENU - 2 - date_final -->
    <div class="d-flex flex-grow-1 px-2 pb-3">
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :nudge-right="40"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date_final_br"
            label=""
            prepend-icon="mdi-calendar"
            readonly
            :prefix="$t('toDateLable')"
            solo-inverted
            hide-details
            dense
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date_final"
          @input="menu2 = false"
          :min="limitRangeDate.min"
          :max="limitRangeDate.max"
          :locale="$t('localeDatepickLable')"
        ></v-date-picker>
      </v-menu>
    </div>
  </div>
</template>
<script>
export default {
  name: "components-filters-range-rangedate",
  data: () => ({
    date_start_br: "",
    date_final_br: "",
    limitRangeDate: {
      min: "",
      max: "",
    },
    // SELECT:
    select: {
      label: "",
      value: "",
    },
    items: [],

    // CALENDAR MENU RANGE:
    date_start: "",
    date_final: "",
    // time_start: "",
    // time_end: "",
    menu1: false,
    menu2: false,
    disabledRangeSelect: false,
    disabledRange: false,
    errorTime: "",
    hideDetails: true,
  }),

  mounted() {
    this.select = this.itemsWeek[0];

    const selectRangeDays = {
      7: this.itemsWeek,
      15: [...this.itemsWeek, ...this.itemsHalfMonth],
      30: [...this.itemsWeek, ...this.itemsHalfMonth, ...this.itemsMonth],
    };

    this.items =
      selectRangeDays[this.$route.meta.filterLimitDays] || selectRangeDays[7];
  },

  computed: {
    // Recuperando o Range armazenado no Store.
    rangeDate() {
      return this.$store.state.range.date;
    },
    itemsWeek() {
      return [
        {
          label: this.$t("lastSevenDaysLable"),
          value: "lastSevenDays",
        },
        {
          label: this.$t("currentWeekLable"),
          value: "currentWeek",
        },
        {
          label: this.$t("lastWeekLable"),
          value: "lastWeek",
        },
      ];
    },
    itemsHalfMonth() {
      return [
        {
          label: this.$t("lastFifteenDaysLable"),
          value: "halfMonth",
        },
      ];
    },
    itemsMonth() {
      return [
        {
          label: this.$t("currentMonthLable"),
          value: this.$t("lasttMonthLable"),
        },
        {
          label: "Mês passado",
          value: "lastMonth",
        },
      ];
    },
  },
  watch: {
    // Se os dois menus estiverem preenchido
    // pode setar no store o range.
    date_start(val) {
      if (val && this.date_final != "") {
        this.date_start_br = this.$dateRange.format(val, "DD/MM/YYYY");
        this.setRangeStore();
      }
    },
    // Se os dois menus estiverem preenchido
    // pode setar no store o range.
    date_final(val) {
      if (val && this.date_start != "") {
        this.date_final_br = this.$dateRange.format(val, "DD/MM/YYYY");
        this.setRangeStore();
      }
    },

    // Mantendo o Select Sincronizado com os menus date picker
    async select(select) {
      if (select == null) return;
      var rangeDate = await this.$dateRange.get[select.value]();

      // Set values
      this.date_start = rangeDate.date_start.slice(0, -13);
      this.date_final = rangeDate.date_final.slice(0, -13);

      // Set textFileds in format "br"
      this.date_start_br = this.$dateRange.format(
        this.date_start,
        "DD/MM/YYYY"
      );
      this.date_final_br = this.$dateRange.format(
        this.date_final,
        "DD/MM/YYYY"
      );
    },
  },
  methods: {
    // Set Menu Range for Store
    setRangeStore() {
      // Set limit range
      let max;
      max = new Date(new Date(this.date_start).setHours(23, 59, 59))
        .add(this.$route.meta.filterLimitDays || 7)
        .toISOString();

      this.limitRangeDate = { min: this.date_start, max };

      var date_start = `${this.date_start}T00:00:00.000`;
      var date_final = `${this.date_final}T23:59:59.000`;

      // Se os dois campos tiverem preenchidos armazenar no Store.
      if (date_start != "" && date_final != "") {
        this.$store.commit("SetRangeDate", { date_start, date_final });
      }
    },
    timeValidated(time) {
      // console.log("method: timeValidated");
      if (time > "23:59:59") {
        this.errorTime = "Horário inválido";
        this.hideDetails = false;
        return;
      }
      this.errorTime = "";
      this.hideDetails = true;

      // Quando Selecionado "Apuração Semanal"
      // Não executar a validação de Time
      // Porque ele já vem do banco de dados correto.
      // E evita erro na UI principalmente
      // quando executa this.setRangeStore() dentro
      // desse escopo.
      if (this.rangeDate.weekly_deal) return;
      this.setRangeStore();
    },
  },
};
</script>
<style scoped>
.range-wrap {
  flex-wrap: wrap;
}
.range-wrap > div {
  flex-basis: 33.3333333333%;
}
</style>
